import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { KeycloakService } from '../services/keycloak.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(private keycloakService: KeycloakService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const logged = await this.keycloakService.isLoggedIn();
    if (logged) return true;

    // Se non loggato, avvia Keycloak login e torna alla rotta richiesta
    await this.keycloakService.login({ redirectUri: window.location.origin + this.router.url });
    return false;
  }
}
